import React from 'react';
import PropTypes from 'prop-types';
import GroupOrderSpendingOptionLabel from 'bento-ordering/group_ordering/components/GroupOrderSpendingOptionLabel';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';

const GroupOrderSpendingOption = ({ option, isSelected, disabled }) => {
  return (
    <FormControlLabel
      disabled={disabled}
      value={option.value}
      control={<Radio sx={{ display: 'none' }} />}
      label={
        <GroupOrderSpendingOptionLabel
          option={option}
          isSelected={isSelected}
        />
      }
    />
  );
};

GroupOrderSpendingOption.propTypes = {
  disabled: PropTypes.bool,
  option: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  isSelected: PropTypes.bool.isRequired
};

export default GroupOrderSpendingOption;
